/**
 * Ordering Component Constants
 *
 * Centralized constants used across ordering components for consistency
 * and easier maintenance.
 */

/**
 * Theme Configuration
 */
export const DEFAULT_THEME = {
    primary: '#dc2626',
    secondary: '#1f2937',
    accent: '#f59e0b',
} as const;

/**
 * Time Slot Configuration
 */
export const TIME_SLOT_INTERVAL_MINUTES = 15;
export const TIME_SLOTS_COUNT = 16; // 4 hours worth of 15-minute intervals

/**
 * Default Values
 */
export const DEFAULT_OPEN_TIME = "11 AM";

/**
 * Image Sizes
 */
export const IMAGE_SIZES = {
    icon: { width: 40, height: 40 },
    logo: { width: 120, height: 40 },
} as const;

/**
 * Feature Flags
 *
 * Toggle these to enable/disable features during development
 */
export const FEATURE_FLAGS = {
    /**
     * @deprecated Delivery availability is now gated PER-RESTAURANT in OrderModal
     * via `restaurant.settings.courierProvider` (matching the server dispatch
     * gate), not a global flag. Kept false for backward-compat; no longer read.
     */
    DELIVERY_COMING_SOON: false,
} as const;

/**
 * Order Types
 */
export type OrderType = 'pickup' | 'delivery';

/**
 * Cart Item Count Display
 */
export const MAX_CART_DISPLAY_COUNT = 99;

/**
 * LocalStorage Keys
 */
export const STORAGE_KEYS = {
    ORDER_CONFIG: 'order-up:order-config',
    SELECTED_TIME: 'order-up:selected-time',
    SCHEDULED_DATE: 'order-up:scheduled-date',
} as const;

